import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.grid}>
            {/* Brand */}
            <div>
              <div style={styles.brandRow}>
                <div style={styles.logo} aria-hidden="true">
                  AT
                </div>
                <div>
                  <div style={styles.title}>Outils Immobilier</div>
                  <div style={styles.sub}>simulateurs & PDF</div>
                </div>
              </div>

              <p style={styles.desc}>
                Outils gratuits pour l’achat, l’investissement et la vente
                immobilière : simulateurs + documents PDF. Calculs réalisés
                localement dans ton navigateur.
              </p>

              <div style={styles.pillsGrid}>
                {/* Ligne 1 */}
                <span style={styles.badge}>100% local</span>
                <span style={styles.badge}>Gratuit</span>
                <span style={styles.badge}>Rapide</span>

                {/* Ligne 2 */}
                <Link to="/mentions-legales" style={styles.legalPill}>
                  Mentions légales
                </Link>
                <Link to="/confidentialite" style={styles.legalPill}>
                  Confidentialité
                </Link>
                <Link to="/cgu" style={styles.legalPill}>
                  CGU
                </Link>
              </div>
            </div>

            {/* Links */}
            {/*
            <div>
              <div style={styles.colTitle}>Pages</div>
              <div style={styles.links}>
                <Link to="/" style={styles.link}>
                  Accueil
                </Link>
                <Link to="/contact" style={styles.link}>
                  Contact
                </Link>
              </div>
              <div style={{ height: 12 }} />
              <div style={styles.colTitle}>Outils</div>
              <div style={styles.links}>
                <Link to="/calcul-mensualite-credit" style={styles.link}>
                  Mensualité crédit
                </Link>
                <Link to="/calcul-capacite-emprunt" style={styles.link}>
                  Capacité d’emprunt
                </Link>
                <Link to="/estimation-frais-notaire" style={styles.link}>
                  Frais de notaire
                </Link>
                <Link to="/calcul-rentabilite-locative" style={styles.link}>
                  Rentabilité locative
                </Link>
                <Link to="/calcul-plus-value-immobiliere" style={styles.link}>
                  Plus-value
                </Link>
                <Link
                  to="/generateur-attestation-hebergement"
                  style={styles.link}
                >
                  Attestation hébergement
                </Link>
              </div>{" "}
              
            </div>
*/}
            {/* Notice */}
            <div>
              <div style={styles.colTitle}>À savoir</div>
              <p style={styles.notice}>
                Les résultats affichés sont des{" "}
                <strong>estimations indicatives</strong>. Pour une décision
                officielle, vérifie toujours avec un professionnel (banque,
                notaire, fiscalité).
              </p>

              <div style={styles.noticeBox}>
                <div style={styles.noticeBoxTitle}>Idées / Bugs ?</div>
                <div style={styles.noticeBoxText}>
                  Dis-moi ce que tu veux ajouter, je peux intégrer de nouveaux
                  outils au fur et à mesure.
                </div>
                <Link to="/contact" style={styles.cta}>
                  Contacter
                </Link>
              </div>
            </div>
          </div>

          <div style={styles.bottom}>
            <span style={{ opacity: 0.75 }}>
              © {new Date().getFullYear()} — AT Outils Immobilier
            </span>
            <span style={styles.dot}>•</span>
            <span style={{ opacity: 0.65 }}></span>
          </div>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    marginTop: 34,
    padding: "0 16px 26px",
  },
  container: {
    maxWidth: 1100,
    margin: "0 auto",
  },
  card: {
    border: "1px solid rgba(255,255,255,.14)",
    background:
      "linear-gradient(180deg, rgba(255,255,255,.10), rgba(255,255,255,.06))",
    backdropFilter: "blur(10px)",
    borderRadius: 22,
    boxShadow: "0 14px 60px rgba(0,0,0,.35)",
    overflow: "hidden",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",

    gap: 18,
    padding: 18,
  },
  brandRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 10,
  },
  logo: {
    width: 42,
    height: 42,
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,.2)",
    display: "grid",
    placeItems: "center",
    fontWeight: 900,
  },
  title: {
    fontWeight: 900,
    letterSpacing: ".3px",
  },
  sub: {
    fontSize: 12,
    opacity: 0.7,
  },
  desc: {
    margin: 0,
    lineHeight: 1.5,
    fontSize: 13,
    opacity: 0.75,
  },
  badges: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 12,
  },
  badge: {
    padding: "7px 10px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,.16)",
    background: "rgba(255,255,255,.08)",
    fontWeight: 750,
    fontSize: 12,
  },
  colTitle: {
    fontWeight: 900,
    marginBottom: 10,
    opacity: 0.9,
  },
  links: {
    display: "grid",
    gap: 8,
  },
  link: {
    textDecoration: "none",
    color: "inherit",
    fontWeight: 700,
    opacity: 0.82,
    padding: "8px 10px",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,.10)",
    background: "rgba(255,255,255,.06)",
  },
  notice: {
    margin: 0,
    fontSize: 13,
    opacity: 0.72,
    lineHeight: 1.5,
  },
  noticeBox: {
    marginTop: 12,
    padding: 14,
    borderRadius: 16,
    border: "1px solid rgba(255,255,255,.14)",
    background: "rgba(255,255,255,.06)",
  },
  noticeBoxTitle: {
    fontWeight: 900,
    marginBottom: 6,
  },
  noticeBoxText: {
    fontSize: 13,
    opacity: 0.75,
    lineHeight: 1.4,
    marginBottom: 10,
  },
  cta: {
    display: "inline-block",
    textDecoration: "none",
    color: "inherit",
    fontWeight: 900,
    padding: "9px 14px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,.22)",
    background: "rgba(255,255,255,.12)",
  },
  bottom: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    padding: "12px 16px",
    borderTop: "1px solid rgba(255,255,255,.10)",
    fontSize: 12,
  },
  legalLinks: {
    marginTop: 12,
    display: "grid",
    gap: 8,
    maxWidth: 240,
  },
  legalPill: {
    textDecoration: "none",
    color: "inherit",
    padding: "7px 10px",
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,.14)",
    background: "rgba(255,255,255,.06)",
    fontWeight: 700,
    fontSize: 12,
    opacity: 0.85,
  },

  dot: {
    opacity: 0.35,
    margin: "0 4px",
  },
  pillsRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 12,
  },
  pillsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, max-content)",
    columnGap: 10, //espace horizontal (inchangé)
    rowGap: 16, // ⬅️ espace vertical entre les lignes
    marginTop: 12,
  },
};

/* Responsive */
const css = `
@media (max-width: 950px){
  ._footer_grid{ grid-template-columns: 1fr; }
}
`;
